module.exports = __webpack_public_path__ + "img/xw1.287cefdd.png";